import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-terracotta disabled:opacity-50 disabled:pointer-events-none cursor-pointer no-underline';
  const variants = {
    primary: 'bg-terracotta text-white hover:bg-terracotta-dark shadow-lg shadow-terracotta/20',
    secondary: 'bg-sage text-white hover:bg-sage-dark shadow-lg shadow-sage/20',
    outline: 'border-2 border-terracotta text-terracotta hover:bg-terracotta/5',
    ghost: 'text-forest hover:bg-sage/10'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg',
    xl: 'h-16 px-10 text-xl font-bold'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const allClasses = `${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`;
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={allClasses} data-id="element-267">
        {children}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={allClasses} {...props} data-id="element-268">
      {children}
    </motion.button>;
}